// extracted by mini-css-extract-plugin
export var hidden = "_50-1";
export var leftPanel = "_50-2";
export var readonlyInspector = "_50-3";
export var rightPanel = "_50-0";